import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookmarkRemove"><Path d="M4.5 17.5V21.5L12 17.5L19.5 21.5V12M19.5 8.25174V2.5H4.5V14.0039" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 15.5L22.5 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBookmarkRemove;
